// removed by extract-text-webpack-plugin
module.exports = {"smallAreaList":"small-area-module__smallAreaList___2J816","smallArea":"small-area-module__smallArea___1SSkC","name":"small-area-module__name___1ySHK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/small-area-list/small-area.module.scss
// module id = 704
// module chunks = 0 1